import { useState, useEffect } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import './topbanner.css';
import images from '../../assets/img/TopBannerSliders';

function TopBanner() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const slides = [
    { id: 1, img: images.slide1 },
    { id: 2, img: images.slide2 },
    { id: 3, img: images.slide3 },
    { id: 4, img: images.slide4 },
  ];

  const getSlideImage = (slide) => {
    if (windowWidth <= 510) {
      return slide.img.mobile;
    } else if (windowWidth <= 1000) {
      return slide.img.min;
    } else {
      return slide.img.max;
    }
  };

  return (
    <div style={{ maxWidth: "2000px", margin: "0 auto" }}>
      <Carousel className="mb-5">
        {slides.map((slide) => (
          <Carousel.Item key={slide.id}>
            <div className="slidewrapper" style={{ textAlign: "center" }}>
              <img
                className="slide1"
                src={getSlideImage(slide)}
                alt={`Slide ${slide.id}`}
              />
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}

export default TopBanner;
